<div class="modal-header">
  <h3 class="fw-bold widget-heading">
    {{ 'EventQuery.Dialog.Title' | translate }}
  </h3>

  <button
    type="button"
    class="btn-close close"
    aria-label="Close button"
    [disabled]="submitting || !canCancel"
    (click)="cancel()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body widget-card-background widget-content">
  @if (onBehalfName) {
    <app-info-notice
      containerClass="mb-3"
      text="EventQuery.Dialog.OnBehalfHint"
      [translateParams]="{ name: onBehalfName }"
    ></app-info-notice>
  }

  <app-dynamic-form
    #queryForm
    [fields]="fields"
    [submitBtnDisplayed]="false"
    [errorsDisplayedOnSave]="true"
    [formValue]="initialFormValue"
    containerClass="jury-form-container"
    (valueChanged)="onValueChanged($event)"
    (formValidityChanged)="formValid = $event"
  ></app-dynamic-form>
</div>

<div class="modal-footer flex-column align-items-center">
  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="submitting || !canCancel"
      (click)="cancel()"
    >
      {{ 'Cancel' | translate | uppercase }}
    </button>

    <button
      type="button"
      class="btn btn-primary ms-2 d-inline-flex align-items-center justify-content-center"
      [disabled]="submitting || !formValid"
      (click)="submit()"
    >
      @if (submitting) {
        <span
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
      }
      <span>{{ submitLabelKey | translate | uppercase }}</span>
    </button>
  </div>

  @if (canSkip) {
    <button
      type="button"
      class="btn btn-unstyled border-0 text-decoration-underline mt-2 fw-normal text-gray font-size-base"
      [disabled]="submitting"
      (click)="skip()"
    >
      {{ 'EventQuery.Dialog.Skip' | translate }}
    </button>
  }
</div>
